interface InsightHighlightedTitleProps {
  title: string;
  highlights?: string[];
}

export function InsightHighlightedTitle({ title, highlights }: InsightHighlightedTitleProps) {
  if (!highlights?.length) return <>{title}</>;

  const parts: { text: string; highlighted: boolean }[] = [];
  let remaining = title;

  while (remaining.length > 0) {
    let earliestIndex = remaining.length;
    let matchedHighlight = '';

    for (const h of highlights) {
      const idx = remaining.indexOf(h);
      if (idx !== -1 && idx < earliestIndex) {
        earliestIndex = idx;
        matchedHighlight = h;
      }
    }

    if (!matchedHighlight) {
      parts.push({ text: remaining, highlighted: false });
      break;
    }

    if (earliestIndex > 0) {
      parts.push({ text: remaining.slice(0, earliestIndex), highlighted: false });
    }
    parts.push({ text: matchedHighlight, highlighted: true });
    remaining = remaining.slice(earliestIndex + matchedHighlight.length);
  }

  return (
    <>
      {parts.map((part, i) =>
        part.highlighted ? (
          <span key={i} className="text-primary">
            {part.text}
          </span>
        ) : (
          <span key={i}>{part.text}</span>
        ),
      )}
    </>
  );
}
